import type { IGrideCell } from "commons/ui/grid/GridVo";
import styled from "styled-components";

/**
 * 숫자 Comma 표시용 Grid 컴포넌트 셀
 * @param props IGrideCell<[number]> {@link IGrideCell}
 * @returns JSX.Element
 */
export function GridLocalStringCell(props: IGrideCell<[number]>): JSX.Element {
  return (
    <>
      <p>{props.data[0] !== undefined ? Number(props.data[0]).toLocaleString("ko-kr") : ""}</p>
    </>
  );
}

const RightP = styled.p`
  text-align: right;
`;
/**
 * 텍스트 셀
 * @param props
 * @returns
 */
export function GridLocalStringRightTextCell(props: IGrideCell<[number]>): JSX.Element {
  return (
    <>
      <RightP>{props.data[0] !== undefined ? Number(props.data[0]).toLocaleString("ko-kr") : ""}</RightP>
    </>
  );
}
